var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4207_2798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.875H7.125V1.5C7.125 1.08586 6.78914 0.75 6.375 0.75H5.625C5.21086 0.75 4.875 1.08586 4.875 1.5V4.875H1.5C1.08586 4.875 0.75 5.21086 0.75 5.625V6.375C0.75 6.78914 1.08586 7.125 1.5 7.125H4.875V10.5C4.875 10.9141 5.21086 11.25 5.625 11.25H6.375C6.78914 11.25 7.125 10.9141 7.125 10.5V7.125H10.5C10.9141 7.125 11.25 6.78914 11.25 6.375V5.625C11.25 5.21086 10.9141 4.875 10.5 4.875Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4207_2798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.027eb81ea01a7536a7ddb0b07f6ff42f.svg";
export { ForwardRef as ReactComponent };